export default {
  Dinheiro: 'MONEY',
  'Cartão de crédito': 'CREDIT_CARD',
  'Cartão de débito': 'DEBIT_CAR',
};
